import { render, staticRenderFns } from "./ChartDataWithBanksSettings.vue?vue&type=template&id=573f6dd2&scoped=true"
import script from "./ChartDataWithBanksSettings.vue?vue&type=script&lang=ts"
export * from "./ChartDataWithBanksSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573f6dd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('573f6dd2')) {
      api.createRecord('573f6dd2', component.options)
    } else {
      api.reload('573f6dd2', component.options)
    }
    module.hot.accept("./ChartDataWithBanksSettings.vue?vue&type=template&id=573f6dd2&scoped=true", function () {
      api.rerender('573f6dd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/ChartDataWithBanksSettings.vue"
export default component.exports